// Deterministic voice → color mapping. Muted "lab instrument" palette —
// distinct hues but all in a similar mid-saturation band so no single
// voice shouts over the others.

const VOICE_COLORS = [
  '#fcd34d', // amber-300
  '#67e8f9', // cyan-300
  '#6ee7b7', // emerald-300
  '#fda4af', // rose-300
  '#c4b5fd', // violet-300
  '#bef264', // lime-300
  '#fdba74', // orange-300
  '#f0abfc', // fuchsia-300
] as const;

const DRUM_HINTS: Record<string, string> = {
  bd: '#fcd34d',
  kick: '#fcd34d',
  sd: '#fda4af',
  sn: '#fda4af',
  snare: '#fda4af',
  cp: '#fda4af',
  clap: '#fda4af',
  hh: '#67e8f9',
  oh: '#67e8f9',
  hat: '#67e8f9',
  cy: '#c4b5fd',
  ride: '#c4b5fd',
};

export function colorForVoice(voice: string): string {
  const hint = DRUM_HINTS[voice.toLowerCase()];
  if (hint) return hint;
  let hash = 0;
  for (let i = 0; i < voice.length; i++) {
    hash = (hash * 31 + voice.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % VOICE_COLORS.length;
  return VOICE_COLORS[idx]!;
}
